// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_q3-0";
export var discountCodeInput = "_q3-1";